import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'

import { Emoji } from 'images'
import { Tooltip } from 'ui'

import ReactionsPicker from '../../modals/ReactionsPicker'
import { postReactionAdd, postReactionDelete } from '../PostListActions'

import './PostReactions.css'

class PostReactions extends PureComponent {
  state = {
    open: false,
  }

  static getDerivedStateFromProps() {
    return { updating: false }
  }

  onAddReaction = (id) => {
    const { post, type, viewer } = this.props
    if (viewer) {
      this.props.postReactionAdd(type, post.id, id)
    }
    this.onPickerClose()
  }

  onDelReaction = (id) => {
    const { post, type, viewer } = this.props
    if (viewer) {
      this.props.postReactionDelete(type, post.id, id)
    }
  }

  onPickerClose = () => this.setState({ open: false })

  onPickerOpen = () => this.setState({ open: true })

  render() {
    const {
      mobile,
      post: { reactions, reactions_summary: reactionsList },
      viewer,
    } = this.props
    const { open } = this.state

    return (
      <div className="text-lg py-1 gap-1 flex flex-wrap *:h-9 *:px-2 *:py-1 *:flex *:gap-1.5 *:items-center *:justify-center *:bg-greyLightest *:border *:border-greyLightest *:rounded-3xl *:cursor-pointer *:text-black">
        {open && <ReactionsPicker autoFocus={!mobile} onClose={this.onPickerClose} onSelect={this.onAddReaction} />}
        {viewer && (
          <button
            className="inline-block text-xs leading-4 !border-greyDark border-dashed hover:shadow-md hover:!border-black !pr-1"
            onClick={this.onPickerOpen}
            type="button"
          >
            <i className="icons large">
              <i className="green smile outline icon" />
              <i className="top right corner yellow add icon" />
            </i>
          </button>
        )}
        {(reactionsList || []).map((reaction) => {
          const owned = !!viewer && (reactions || []).find((r) => r.reaction === reaction.reaction)
          const id = reaction.reaction
          return (
            <Tooltip
              key={id}
              tooltip={
                <div className="p-1 text-lg flex flex-col items-center">
                  <div className="flex items-center justify-center size-5 text-5xl leading-4 border overflow-hidden rounded">
                    <Emoji name={id} />
                  </div>
                  <div className="pt-2">
                    {reaction.count === 1 && owned && 'Solo tú'}
                    {reaction.count === 2 && owned && 'Tú y otro usuario'}
                    {reaction.count > 2 && owned && `Tú y otros ${reaction.count - 1} usuarios`}
                    {reaction.count === 1 && !owned && 'Un usuario'}
                    {reaction.count > 1 && !owned && `${reaction.count} usuarios`}
                  </div>
                </div>
              }
            >
              <button
                className={classnames(
                  'inline-block hover:shadow-md hover:border-grey',
                  owned && '!border-greenLight !bg-greenLightest',
                )}
                onClick={owned ? () => this.onDelReaction(id) : () => this.onAddReaction(id)}
                type="button"
              >
                <Emoji className="text-2xl leading-4" name={id} /> {reaction.count}
              </button>
            </Tooltip>
          )
        })}
      </div>
    )
  }
}

PostReactions.propTypes = {
  post: PropTypes.object.isRequired,
  postReactionAdd: PropTypes.func.isRequired,
  postReactionDelete: PropTypes.func.isRequired,

  mobile: PropTypes.bool,
  type: PropTypes.oneOf([
    'advertising',
    'institution',
    'sports_soccer_match',
    'sports_soccer_team',
    'sports_tournament',
    'stats',
    'user',
  ]).isRequired,
  viewer: PropTypes.object,
}

PostReactions.defaultProps = {
  mobile: false,
  viewer: null,
}

export default connect(
  (state) => ({
    mobile: state.environment.device.mobile,
    viewer: state.auth.usr,
  }),
  {
    postReactionAdd,
    postReactionDelete,
  },
)(PostReactions)
